import { StepperTheme } from '../../types';

export const STEPPER_DEFAULT_THEME: StepperTheme = {
    chevronSize: 16,
    chevronColor: 'text.heading',
    checkSize: 16,
    labelSpacing: 1.5,
    underlineHeight: 3,
    underlineColor: 'text.heading',
    labelFontWeight: {
        completed: 'semiBold',
        active: 'bold',
    },
};
